/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
// import { removeComponentAnimation } from '@Animations/index';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { SyncLoader } from 'react-spinners';
import { cn } from '@/utils';
import Button from '@/ui/_lib/Button';
import Portal from '@/ui/_lib/Portal';
import DeleteConfirmationOverlay from '@/ui/_lib/Portal/DeleteConfirmationOverlay';
import Skeleton from '../../_lib/Skeleton';
import { FileData } from '..';

interface FileCardProps {
  file: FileData;
  className?: string;
  handleDeleteFile?: (file: FileData) => void;
  index?: number;
  deleteDocument?: () => void;
  deleteFileStatus?: { isLoading: boolean };
}

const FileCard: React.FC<FileCardProps> = ({
  file,
  className,
  handleDeleteFile,
  index = 0,
  deleteDocument,
  deleteFileStatus,
}) => {
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);

  return (
    <>
      <div className="overflow-hidden rounded-lg transition-all duration-500">
        <motion.div
          initial={{ opacity: 0, transform: 'translateX(-50%)' }}
          animate={{ opacity: 1, transform: 'translateX(0%)' }}
          exit={{
            opacity: 1,
            transform: 'translateX(-100%)',
            background: '#EFBDBD',
            transition: { delay: 0 },
          }}
          transition={{ duration: 0.2, ease: 'easeOut', delay: index * 0.1 }}
          className={cn(
            'flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-3 py-2',
            className,
          )}
        >
          <div className="info flex flex-1 items-center gap-3">
            <img
              src={file.url}
              className="flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-primary-50  group-hover:bg-primary-50"
              alt="file-preview"
            />
            <div className="description flex flex-col items-start justify-center">
              <p className="body-md text-gray-800">{file.title}</p>
              {/* {!file.file && (
                <div className="meta flex gap-1">
                  <p className="tooltip text-primary-500">A02</p>
                  <p className="body-sm text-gray-600">
                    Uploaded on {file.date_created ? format(new Date(file.date_created), 'dd/MM/yyyy') : '-'}
                  </p>
                </div>
              )} */}
            </div>
          </div>
          <div className="actions flex items-center justify-center gap-3">
            <Button
              variant="secondary"
              size="small"
              onClick={() => {
                setConfirmDelete(true);
              }}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white p-0 hover:bg-gray-50"
            >
              {deleteFileStatus?.isLoading ? (
                <SyncLoader color="#039BE5" speedMultiplier={2} size={5} margin={2} />
              ) : (
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-[#039BE5]"
                >
                  <path 
                    d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" 
                    fill="currentColor"
                  />
                </svg>
              )}
            </Button>
          </div>
        </motion.div>
      </div>

      {confirmDelete && (
        <Portal>
          <DeleteConfirmationOverlay
            onClose={() => {
              setConfirmDelete(false);
            }}
            onDelete={() => {
              if (!file.file && deleteDocument) deleteDocument();
              if (handleDeleteFile) handleDeleteFile(file);
            }}
          />
        </Portal>
      )}
    </>
  );
};

export default FileCard;

export const FileCardSkeleton: React.FC = () => {
  return (
    <div className="overflow-hidden rounded-lg transition-all duration-500">
      <motion.div
        initial={{ opacity: 0, transform: 'translateY(-50%)' }}
        animate={{ opacity: 1, transform: 'translateY(0%)' }}
        exit={{
          opacity: 1,
          transform: 'translateY(-100%)',
          background: '#EFBDBD',
          transition: { delay: 0 },
        }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        className={cn('flex w-full items-center justify-between rounded-lg border border-gray-300 bg-white px-3 py-2')}
      >
        <div className="info flex w-3/5 items-center gap-3">
          <Skeleton className="h-[25px] w-[25px] items-center justify-center rounded-full border p-2 text-center" />
          <div className="description flex w-2/3 flex-col items-start justify-center gap-1">
            <Skeleton className="body-md w-full bg-gray-300 text-gray-800" />
            <div className="meta flex w-full gap-1">
              <Skeleton className="h-2 w-1/5" />
              <Skeleton className="h-2 w-4/5" />
            </div>
          </div>
        </div>
        <div className="actions flex w-2/5 items-center justify-center gap-3">
          <Skeleton className="w-3/5 border  p-2 text-center" />
          <Skeleton className="w-1/5 border  p-2 text-center" />
          <Skeleton className="w-1/5 border  p-2 text-center" />
        </div>
      </motion.div>
    </div>
  );
};
